<template lang="pug">
v-container.pt-8(style="max-width:960px")
  div.d-flex.align-center
    v-text-field(v-model="searchText" :placeholder="$t('search')" hide-details dense outlined height="40" :background-color="$colors.basic200" @keyup="queryChanged")
      template(v-slot:append)
        eva-icon(name="search-outline" :fill="$colors.primary400")
    template(v-if="isMobileScreen")
      v-btn.ml-3(@click="" icon )
        v-icon(left color="info") mdi-plus
    template(v-else)
      v-spacer
      v-btn.button-Aa-medium.px-6(color="info" outlined height="48" style="border-radius: 8px;" @click="clickAddCampaign")
        v-icon(left) mdi-plus
        | {{ $t('new_campaign') }}

  div.d-flex.align-center.mt-4(v-if="!isMobileScreen")
    v-btn.button-Aa-small(v-if="selectedCampaigns.length && !isSelectionMode" @click="onDelete" color="danger500" height=32 outlined depressed) {{ $t('delete') }}
    v-spacer
    y-pagination-custom(v-model="currentPage" :parentPageSize.sync="pageSize" :count="totalCount" :text="$t('show')" @input="pageChanged")
  .data-table
    v-data-table.mt-sm-4.pb-16(:headers="headers" :items="campaigns" item-key="id" :items-per-page="pageSize" hide-default-footer disable-sort :loading="isFetching")
      template(v-slot:no-data)
        .mt-16
          v-img.mx-auto(src="@/assets/images/icon_empty.png" width=80)
          .mt-2.p2.basic600--text {{ $t('no_list_available') }}
      template(v-slot:header.checked)
        yc-checkbox(v-model="checkAll" @change="onCheckedAll")
      template(v-slot:item.checked="{ item, isMobile, headers, index }")
        yc-checkbox(v-model="item.checked" @change="onChecked")
      template(v-slot:item.title="{ item, isMobile, headers, index }")
        .p1.info500--text.clickable(@click="clickItem(item)") {{ item.title }}
      template(v-slot:item.donated_amount="{ item, isMobile, headers, index }")
        div {{ item.donated_amount | displayPrice($currency) }}
    .py-8
    .yc-fixed-bottom-section(v-if="isMobileScreen")
      y-pagination-custom(v-model="currentPage" :parentPageSize.sync="pageSize" :count="totalCount" text="Show campaigns" @input="pageChanged")
      slot(name="actions")
  
  .modals
    delete-campaign-dialog(v-if="showDeleteDialog" :open.sync="showDeleteDialog" :campaigns="selectedCampaigns" @deleted="successDeleteCampaign")

</template>

<script>
import { debounce } from '@/utils'
import { mapGetters, mapActions } from 'vuex'
import DeleteCampaignDialog from '@/components/donation/dialogs/DeleteCampaignDialog.vue'

export default {
  name: 'Campaign',
  props: {
    isSelectionMode: {
      type: Boolean,
      default: false
    },
  },
  components: {
    DeleteCampaignDialog
  },
  data: () => ({
    isFetching: false,
    searchText: '',
    pageSize: 20,
    totalCount: 0,
    currentPage: 1,
    campaigns: [],
    selectedCampaigns: [],
    showFilterDrawer: false,
    isDeleting: false,
    headers: [
      {
        text: '',
        value: 'checked',
        enable: true,
        class: 'p2 basic600--text text-uppercase'
      },
      {
        text: 'Campaign',
        value: 'title',
        enable: true,
        class: 'p2 basic600--text text-uppercase'
      },
      {
        text: 'Donor',
        value: 'donor_count',
        enable: true,
        class: 'p2 basic600--text text-uppercase'
      },
      {
        text: 'Raised',
        value: 'donated_amount',
        enable: true,
        class: 'p2 basic600--text text-uppercase'
      },
      {
        text: 'Fundraiser',
        value: 'fundraiser_count',
        enable: true,
        class: 'p2 basic600--text text-uppercase'
      },
      {
        text: 'Status',
        value: 'status',
        enable: true,
        class: 'p2 basic600--text text-uppercase'
      }
    ],
    checkAll: false,
    showDeleteDialog: false,
    showAddDialog: false
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    isMobileScreen() {
      return this.$vuetify.breakpoint.xs
    }
  },
  watch: {},
  mounted () {
    this.fetchCampaigns(1)
  },
  methods: {
    ...mapActions(['showMessage']),
    addFilter() {
      this.showFilterDrawer = true
    },
    fetchCampaigns(page, query) {
      this.isFetching = true
      const params = {
        page_size: this.pageSize,
        page,
        search: query || ''
      }
      this.$axios.get(`/donations/${this.company.slug}/campaigns`, { params })
        .then(resp => {
          if (resp?.data.results) {
            this.campaigns = resp.data.results
            this.campaigns.map(m => m.checked = false)
          }
          this.totalCount = resp.data.count
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    pageChanged(num) {
      this.fetchCampaigns(num)
    },
    queryChanged: debounce(function () {
      this.fetchCampaigns(1, this.searchText)
    }, 750),
    successDeleteCampaign() {
      this.reset()
    },
    clickAddCampaign () {
      this.isFetching = true
      this.$axios.post(`/donations/${this.company.slug}/campaigns`)
        .then(resp => {
          this.clickItem(resp.data.form)
          // resp.data.form.slug
          // this.fetchCampaigns(1)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          this.isFetching = false
        })
    },
    clickItem (item) {
      this.$router.push(`/admin/donation/campaign/${item.slug}`)
    },
    onChecked() {
      this.selectedCampaigns = this.campaigns.filter(item => item.checked === true)
      this.campaigns = [...this.campaigns]
      this.checkAll = false
      this.emitselectedCampaigns()
    },
    onCheckedAll() {
      const clone = [...this.campaigns]
      clone.map(item => item.checked = this.checkAll)
      this.campaigns = [...clone]
      this.selectedCampaigns = this.campaigns.filter(item => item.checked === true)
      this.emitselectedCampaigns()
    },
    clearSelection() {
      this.checkAll = false
      this.onCheckedAll()
    },
    onDelete() {
      this.showDeleteDialog = true
    },
    onAddSegment() {
      this.showAddDialog = true
    },
    // successAddCustomer() {
    //   this.reset()
    // },
    reset() {
      this.checkAll = false
      this.selectedCampaigns = []
      this.fetchCampaigns(1)
    },
    emitselectedCampaigns() {
      this.$emit('onselectedCampaigns', this.selectedCampaigns)
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.clickable {
  cursor: pointer;
}
</style>